module.exports = __webpack_public_path__ + "static/media/ai-icon.47ed7d4c.svg";